import { IRepository } from "@karma-games/angular-devkit/src/lib/interfaces";
import { EBetSplit, IRoundBet } from "../core/round/interfaces";

export interface IStatisticsRepository extends IRepository<IRoundBet[]> {}

export interface IBetStatisticsRecordPayload {
    bet: number;
    payout: number;
    currency: string;
    multiplier: number;
    player?: {
        id?: string;
        avatarUrl: string;
        name: string;
    },
    createdAt: number;
    split: EBetSplit;
}

export interface IMyBetStatisticsRecordPayload {
    multiplier: number;
    bet: number;
    payout: number;
    currency: string;
    createdAt: number;
    status: EStatsRecordStatus;
    split: EBetSplit;
}

export enum EStatsRecordStatus {
    Won = "won",
    Lost = "lost",
    Pending = "pending"
}
